import { Box, Typography } from "@mui/material";
import { Icons } from "../../assets/icon";
import AccessTimeIcon from "@mui/icons-material/AccessTime";

export default function TimeDuration({ duration }: { duration: number }) {
  return (
    <Box
      sx={{
        display: "flex",
        padding:
          "var(--spacing-1x) var(--spacing-2x) var(--spacing-1x) var(--spacing-1x)",
        alignItems: "center",
        gap: " var(--spacing-1x)",
        borderRadius: "var(--spacing-8x)",
        background: "var(--primary-100)",
        height: "28px",
      }}
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          padding: "2px var(--spacing-1x)",
          gap: "var(--Spacing-1x)",
          borderRadius: "16px",
          background: "var(--neutralWhite)",
        }}
      >
        <AccessTimeIcon
          sx={{
            color: "var(--primary-600)",
            stroke: "1.33px",
            fontSize: { xs: 13, sm: 13, md: 18 },
            height: "16px",
            width: "16px",
          }}
        />
      </Box>
      <Typography
        sx={{
          font: "var(--body-xs)",
          color: "var(--neutral-1000)",
          fontSize: {
            xs: "10px",
            sm: "12px",
          },
        }}
      >
        {`${duration} min`}
      </Typography>
    </Box>
  );
}
